import { Component } from '@angular/core';

import { EndorsementBase } from '../../models';

@Component({
    selector: 'app-signature-endorsement',
    templateUrl: './signature-endorsement.component.html',
    styleUrls: ['./signature-endorsement.component.scss'],
    standalone: false
})
export class SignatureEndorsementComponent extends EndorsementBase {

  endorsementClicked(): void {
    this.signEndorsement.emit({
      endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
      endorsementType: this.endorsementLocation.endorsementTypeCode,
      packageUserGuid: this.endorsementLocation.packageUserGuid,
    });
  }

  eraseEndorsementClicked(): void {
    this.eraseSignedEndorsement.emit({
      endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
      endorsementType: this.endorsementLocation.endorsementTypeCode,
      packageUserGuid: this.endorsementLocation.packageUserGuid,
    });
  }

  get shouldDisable() {
    return this.isEndorsementDisabled || this.areAllEndorsementsSigned;
  }
}
